import { __read } from "tslib";
import React from 'react';
import { useBannerStore } from '../hooks';
import { BannerStateContext, SetBannerStateContext } from '../store';
export var BannerProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useBannerStore(), 2), state = _b[0], setState = _b[1];
    return (React.createElement(BannerStateContext.Provider, { value: state },
        React.createElement(SetBannerStateContext.Provider, { value: setState }, children)));
};
//# sourceMappingURL=BannerProvider.js.map